/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class TelegramAudienceAPI extends ApiClient {
  constructor() {
    super('telegram_audiences', { accountScoped: true });
  }

  getAudience({ botInboxId, page = 1, perPage = 50, query = '' }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    params.append('page', String(page));
    params.append('per_page', String(perPage));
    if (query) params.append('q', query);

    return axios.get(`${this.url}?${params.toString()}`);
  }

  getStatistics({ botInboxId, since, until }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    if (since) params.append('since', String(since));
    if (until) params.append('until', String(until));

    return axios.get(`${this.url}/statistics?${params.toString()}`);
  }

  getChannelsGroups({ botInboxId, query = '' }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    if (query) params.append('q', query);

    return axios.get(`${this.url}/channels_groups?${params.toString()}`);
  }

  getBotSettings({ botInboxId }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    return axios.get(`${this.url}/bot_settings?${params.toString()}`);
  }

  updateBotSettings({ botInboxId, commands, permanentMenu }) {
    return axios.patch(`${this.url}/update_bot_settings`, {
      bot_inbox_id: String(botInboxId),
      commands,
      permanent_menu: permanentMenu,
    });
  }

  importAudience({ botInboxId, file }) {
    const formData = new FormData();
    formData.append('bot_inbox_id', String(botInboxId));
    formData.append('import_file', file);

    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getImportStatus({ botInboxId, importId }) {
    const params = new URLSearchParams();
    params.append('bot_inbox_id', String(botInboxId));
    if (importId) params.append('import_id', String(importId));
    return axios.get(`${this.url}/import_status?${params.toString()}`);
  }
}

export default new TelegramAudienceAPI();
